require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/analytics/legacy/framework/utils/anly-utils-basketpage.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/analytics/legacy/framework/utils/anly-utils-basketpage.legacy.js
// module id = 785
// module chunks = 31